export default "__VITE_ASSET__DXqP6rlK__"